'use strict';

var React = require('react');

var SvgTransactionFeeDollarIcon = function SvgTransactionFeeDollarIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4 5.25a2.25 2.25 0 0 1 4.372-.75h3.256a2.251 2.251 0 1 1 0 1.5h-2.878v5.25c0 .69.56 1.25 1.25 1.25h.25a.75.75 0 0 1 0 1.5h-.25a2.75 2.75 0 0 1-2.75-2.75v-3.984a2.25 2.25 0 0 1-3.25-2.016Zm2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 10.107a1.876 1.876 0 0 0 .625 3.643h.75a.375.375 0 0 1 0 .75h-1.875a.75.75 0 0 0 0 1.5h.5v.25a.75.75 0 0 0 1.5 0v-.254a1.875 1.875 0 0 0-.125-3.746h-.75a.375.375 0 0 1 0-.75h1.875a.75.75 0 0 0 0-1.5h-1v-.25a.75.75 0 0 0-1.5 0v.357Z"
  }));
};
SvgTransactionFeeDollarIcon.displayName = "TransactionFeeDollarIcon";

exports.SvgTransactionFeeDollarIcon = SvgTransactionFeeDollarIcon;
